import { formatTime } from "@clipboard-health/date-time";
import { Input, Text, useModalState } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { useCallback } from "react";

import { DigitalClockInputBottomSheet } from "../../../DateTime/DigitalClockInputBottomSheet";

interface TimeInputProps {
  label: string;
  value?: Date;
  onChange: (time: Date) => void;
  disabled?: boolean;
  error?: boolean;
  required?: boolean;
  minutesStep?: number;
}

export function TimeInput(props: TimeInputProps) {
  const {
    label,
    value,
    onChange,
    disabled = false,
    error = false,
    required = false,
    minutesStep = 5,
  } = props;

  const modalState = useModalState();

  const handleTimeSelect = useCallback(
    (selectedTime: Date) => {
      onChange(selectedTime);
      modalState.closeModal();
    },
    [onChange, modalState]
  );

  return (
    <>
      <Stack spacing={2}>
        <Text semibold variant="body1">
          {label}
          {required && " *"}
        </Text>
        <Input
          fullWidth
          readOnly
          placeholder="Select time"
          value={value ? formatTime(value) : ""}
          error={error}
          disabled={disabled}
          iconType="clock"
          sx={{
            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.palette.background.paper,
              cursor: disabled ? "default" : "pointer",
            },
            "& .MuiInputBase-input": {
              cursor: disabled ? "default" : "pointer",
            },
          }}
          onClick={() => {
            if (!disabled) {
              modalState.openModal();
            }
          }}
        />
      </Stack>

      <DigitalClockInputBottomSheet
        modalState={modalState}
        title={label}
        initialTime={value}
        minutesStep={minutesStep}
        confirmButtonText="Confirm"
        onConfirm={handleTimeSelect}
      />
    </>
  );
}
